import { useState } from 'react';

import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

import ButtonWithLoader from 'shared/components/Button/ButtonWithLoader/ButtonWithLoader';
import InputForm from 'shared/components/Input/InputForm';
import { APIErrorT } from 'shared/models/api';
import { LoginT } from 'shared/models/auth';
import accessToken from 'utils/accessToken';
import api from 'utils/api';
import authToken from 'utils/authToken';
import { useAuth } from 'utils/hooks/providers/auth-context';

import './Login.scss';

type FormData = {
  username: string;
  password: string;
};

interface LoginProps {
  location: any; // LocationDescriptor<unknown>
}
function Login({ location }: LoginProps) {
  const { register, handleSubmit } = useForm<FormData>();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const history = useHistory();
  const { setAuthState } = useAuth();

  const handleToken = (token: string) => {
    const tokenExtractedData = authToken.extractData(token);
    accessToken.set(token);
    setAuthState({
      ...tokenExtractedData,
    });
  };

  const onSubmit = (form: FormData) => {
    if (form.username !== '' && form.password !== '') {
      setIsLoading(true);
      setErrorMessage('');
      api.auth.login(form.username, form.password)
        .then((resp: any) => {
          if (resp.status >= 400) {
            resp.json()
              .then((error: APIErrorT) => {
                let message = error?.message;
                if (message === 'failed to login: invalid credentials') {
                  message = 'Username or password invalid';
                }
                setErrorMessage(message);
              });
            setIsLoading(false);
          } else {
            resp.json()
              .then((data: LoginT) => {
                handleToken(data.access_token);
                setIsLoading(false);
                if (location?.state?.referrer) {
                  // user came from an internal link
                  history.push(location.state.referrer);
                } else {
                  // user came from a bookmark or an external link
                  history.push('/');
                }
              });
          }
        });
    }
  };

  return (
    <div className="login form box box--radius box--center">
      <h1>Connexion</h1>
      <form className="login--form" onSubmit={handleSubmit(onSubmit)}>
        <InputForm.TextField
          fullWidth
          sx={{ mb: 1.5 }}
          label="Username"
          type="text"
          register={register('username')}
          autoComplete="true"
          required
        />
        <InputForm.TextField
          fullWidth
          sx={{ mb: 1.5 }}
          label="Password"
          type="password"
          register={register('password')}
          autoComplete="true"
          required
        />
        <ButtonWithLoader
          label="Login"
          isLoading={isLoading}
          type="submit"
        />
        {errorMessage ? <p className="text-error text-center">{errorMessage}</p> : null}
      </form>
      <p className="subtitle text-center">By Acklio</p>
    </div>
  );
}

export default Login;
